const convertMassVolume = (unit, quantity, density) => {
    // Normalize unit (handle plural forms and variations)
    const unitMap = {
        'cups': 'cup',
        'tablespoons': 'tbsp',
        'teaspoons': 'tsp',
        'fluid ounces': 'fl oz',
        'fluid ounce': 'fl oz',
        'milliliters': 'ml',
        'liters': 'l',
        'grams': 'g',
        'kilograms': 'kg',
        'ounces': 'oz',
        'ounce': 'oz',
        'pounds': 'lb',
        'pound': 'lb'
    };
    
    const normalizedUnit = unitMap[unit?.toLowerCase().trim()] || unit?.toLowerCase().trim();
    
    // Base conversions to grams and cups
    const massConversions = {
        'g': 1,
        'kg': 1000,
        'oz': 28.3495,
        'lb': 453.592
    };

    const volumeConversions = {
        'cup': 1,
        'tbsp': 0.0625,
        'tsp': 0.0208333,
        'fl oz': 0.125,
        'ml': 0.00422675,
        'l': 4.22675
    };

    let results = {};

    // If no density provided or density is not a valid number, only convert within same measurement type
    const hasValidDensity = density && !isNaN(density) && density > 0;
    
    if (!hasValidDensity) {
        if (normalizedUnit in massConversions) {
            // Convert mass measurements
            const grams = quantity * massConversions[normalizedUnit];
            results = {
                'g': grams,
                'kg': grams / 1000,
                'oz': grams / 28.3495,
                'lb': grams / 453.592
            };
        } else if (normalizedUnit in volumeConversions) {
            // Convert volume measurements
            const cups = quantity * volumeConversions[normalizedUnit];
            results = {
                'cup': cups,
                'tbsp': cups * 16,
                'tsp': cups * 48,
                'fl oz': cups * 8,
                'ml': cups * 236.588,
                'l': cups * 0.236588
            };
        }
        return results;
    }

    // If density provided (g/cup), convert between mass and volume
    let baseMass; // in grams
    let baseVolume; // in cups

    if (normalizedUnit in massConversions) {
        baseMass = quantity * massConversions[normalizedUnit];
        baseVolume = baseMass / density;
    } else if (normalizedUnit in volumeConversions) {
        baseVolume = quantity * volumeConversions[normalizedUnit];
        baseMass = baseVolume * density;
    }

    // Return all possible conversions
    return {
        // Mass conversions
        'g': baseMass,
        'kg': baseMass / 1000,
        'oz': baseMass / 28.3495,
        'lb': baseMass / 453.592,
        // Volume conversions
        'cup': baseVolume,
        'tbsp': baseVolume * 16,
        'tsp': baseVolume * 48,
        'fl oz': baseVolume * 8,
        'ml': baseVolume * 236.588,
        'l': baseVolume * 0.236588
    };
};

export default convertMassVolume;
